import accountService from './ws';

export default accountService;